import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import { getBoardClientProfiles } from "./board-api";
const BOARD_CLIENT_PROFILE_PAGE_SIZE = 250;
const BOARD_CLIENT_PROFILE_PAGE_REQUESTS = 2;
const waitForBrowserPaint = () => new _Promise(resolve => {
  if (typeof window === "undefined") {
    setTimeout(resolve, 0);
    return;
  }
  window.requestAnimationFrame(() => resolve());
});
const getRemainingPageOffsets = total => {
  const offsets = [];
  for (let offset = BOARD_CLIENT_PROFILE_PAGE_SIZE; offset < total; offset += BOARD_CLIENT_PROFILE_PAGE_SIZE) {
    offsets.push(offset);
  }
  return offsets;
};
const loadRemainingPages = async (boardId, offsets, onPage, getPage = getBoardClientProfiles) => {
  for (let index = 0; index < offsets.length; index += BOARD_CLIENT_PROFILE_PAGE_REQUESTS) {
    const batchOffsets = _sliceInstanceProperty(offsets).call(offsets, index, index + BOARD_CLIENT_PROFILE_PAGE_REQUESTS);
    const pages = await _Promise.all(_mapInstanceProperty(batchOffsets).call(batchOffsets, offset => getPage(boardId, offset, BOARD_CLIENT_PROFILE_PAGE_SIZE)));
    for (let pageIndex = 0; pageIndex < pages.length; pageIndex++) {
      await onPage(pages[pageIndex], {
        isFirstPage: false,
        offset: batchOffsets[pageIndex]
      });
      await waitForBrowserPaint();
    }
  }
};
export const getBoardClientProfilePages = async (boardId, onPage, getPage = getBoardClientProfiles) => {
  const firstPage = await getPage(boardId, 0, BOARD_CLIENT_PROFILE_PAGE_SIZE);
  await onPage(firstPage, {
    isFirstPage: true,
    offset: 0
  });
  const remainingPagesPromise = loadRemainingPages(boardId, getRemainingPageOffsets(firstPage.total), onPage, getPage);
  return {
    firstPage,
    remainingPagesPromise
  };
};
export const getAllBoardClientProfiles = async (boardId, getPage = getBoardClientProfiles) => {
  var _context;
  const pages = [];
  const {
    firstPage,
    remainingPagesPromise
  } = await getBoardClientProfilePages(boardId, page => {
    pages.push(page);
  }, getPage);
  await remainingPagesPromise;
  const statistics = _mapInstanceProperty(_context = firstPage.statistics).call(_context, statistic => {
    var _context2;
    return _reduceInstanceProperty(_context2 = _sliceInstanceProperty(pages).call(pages, 1)).call(_context2, (total, page) => {
      var _context3;
      const pageStatistic = _findInstanceProperty(_context3 = page.statistics).call(_context3, ({
        id
      }) => id === statistic.id);
      return _objectSpread(_objectSpread({}, total), {}, {
        count: total.count + ((pageStatistic == null ? void 0 : pageStatistic.count) || 0),
        value: total.value + ((pageStatistic == null ? void 0 : pageStatistic.value) || 0)
      });
    }, statistic);
  });
  return _objectSpread(_objectSpread({}, firstPage), {}, {
    clientProfiles: _flatMapInstanceProperty(pages).call(pages, page => page.clientProfiles),
    statistics
  });
};